import { useAppStore } from '@/store/app-store';
import { useConfigStore } from '@/store/config-store';
import { useAuthStore } from '@/store/auth-store';
import { useHeartbeat } from '@/hooks/useHeartbeat';
import { useProtocolHandler } from '@/hooks/useProtocolHandler';
import { useAuthRefresh } from '@/hooks/useAuthRefresh';
import { Header } from '@/components/Header';
import { BottomNav } from '@/components/BottomNav';
import { Toast } from '@/components/Toast';
import { LoginScreen } from '@/screens/LoginScreen';
import { SetupScreen } from '@/screens/SetupScreen';
import { ScannerScreen } from '@/screens/ScannerScreen';
import { HistoryScreen } from '@/screens/HistoryScreen';
import { StatsScreen } from '@/screens/StatsScreen';
import { ConfigScreen } from '@/screens/ConfigScreen';

export default function App() {
  const screen = useAppStore((s) => s.screen);
  const isConfigured = useConfigStore((s) => s.isConfigured);
  const isAuthenticated = useAuthStore((s) => s._isAuthenticated);

  // Background hooks — heartbeat ping, deep-link protocol handler, token refresh.
  useHeartbeat();
  useProtocolHandler();
  useAuthRefresh();

  // Step 1: Authentication gate — must log in first.
  if (!isAuthenticated) {
    return (
      <div className="h-full w-full bg-surface relative flex flex-col">
        <LoginScreen />
        <Toast />
      </div>
    );
  }

  // Step 2: Configuration gate — event must be set up.
  if (!isConfigured) {
    return (
      <div className="h-full w-full bg-surface relative flex flex-col">
        <SetupScreen />
        <Toast />
      </div>
    );
  }

  return (
    <div className="h-full w-full bg-surface relative flex flex-col">
      <Header />

      <main className="flex-1 overflow-y-auto pb-16">
        {screen === 'scanner' && <ScannerScreen />}
        {screen === 'history' && <HistoryScreen />}
        {screen === 'stats' && <StatsScreen />}
        {screen === 'config' && <ConfigScreen />}
      </main>

      <BottomNav />
      <Toast />
    </div>
  );
}
